'use client';

import React from 'react';

import type { Coords } from '@/common/types/vip-vendor-contact-us.type';
import { ConfigProvider, Skeleton, message } from 'antd';

import { useGetContactUs } from '@/common/apis/dedicated-personal-page/contact-us.api';
import EmptyState from '@/common/components/empty-state';
import { DEFAULT_COORDS } from '@/common/constants/coordinates.constant';
import { mapToUI } from '@/common/utils/contact-us-map.utility';

import SectionPanel from './section-panel.component';

const Main = () => {
  const { data, isLoading, isError } = useGetContactUs();

  if (isError) {
    message.error('دریافت اطلاعات تماس ناموفق بود');
  }

  const contactData = mapToUI(
    data?.data ?? [],
    DEFAULT_COORDS as Coords,
    16
  ).sort((a, b) => {
    return a.isActive < b.isActive ? 1 : -1;
  });

  return (
    <ConfigProvider direction="rtl">
      <div className="mx-auto max-w-5xl px-1 md:px-4 ">
        <h1 className="mb-4 text-center text-lg font-bold">تماس با ما</h1>

        {isLoading ? (
          <div className="space-y-4">
            <Skeleton active />
            <Skeleton active />
          </div>
        ) : contactData.length ? (
          <div className="space-y-4">
            {contactData.map((branch) => (
              <SectionPanel key={branch.id} branch={branch} />
            ))}
          </div>
        ) : (
          <EmptyState
            className="!static z-0 mb-[140px] mt-[107px]"
            iconSrc="/assets/images/svg/empty-state.svg"
            message="این صفحه به زودی کامل می‌شه!"
          />
        )}
      </div>
    </ConfigProvider>
  );
};

export default Main;
